export enum InterestPeriodType {
  Euribor = 'EURIBOR',
  Fixed = 'FIXED',
  Variable = 'VARIABLE'
}
